/** Fallback when neither the host nor the caller names a currency. */
export const DEFAULT_CURRENCY = 'USD'

/**
 * Formats an amount in the host's currency and locale: `$10` (es-MX, MXN),
 * `S/ 10` (es-PE, PEN). Whole amounts drop the cents, as stakes do on the
 * cards; anything else keeps the currency's own minor units.
 */
// Keep this implementation in lockstep with the plain-JS copy in apps/shared/pkg/prepacks/templateRendering.js.
export function formatMoney(
  amount: number,
  currency: string = DEFAULT_CURRENCY,
  locale?: string,
  { wholeWithoutCents = false }: { wholeWithoutCents?: boolean } = {},
): string {
  const roundedAmount = Math.round(amount * 100) / 100
  const options: Intl.NumberFormatOptions = { style: 'currency', currency }
  if (wholeWithoutCents && Number.isInteger(roundedAmount)) options.minimumFractionDigits = 0
  try {
    return new Intl.NumberFormat(locale, options).format(roundedAmount)
  } catch {
    // An unknown currency code or locale must not take the card down.
    return new Intl.NumberFormat(undefined, { ...options, currency: DEFAULT_CURRENCY }).format(roundedAmount)
  }
}
